// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

import * as Sentry from '@sentry/browser';

if (process.env.SENTRY_DSN_JS && (process.env.RAILS_ENV === 'staging' || process.env.RAILS_ENV === 'production')) {
  Sentry.init({
    dsn: process.env.SENTRY_DSN_JS,
    environment: process.env.RAILS_ENV,
    sampleRate: 0.01,
    tracesSampleRate: 0.01
  });
  if (gon && gon.user) {
    const scope = Sentry.getCurrentScope();
    scope.setUser({ id: gon.user.id });
  }
}

import '../src/carousel';
import '../src/carousel_early_birds';
import '../src/carousel_early_birds__sp';
import '../src/carousel_early_bird_king';
import '../src/carousel_early_bird_king__sp';
import '../src/stay_packages-submenu';
import '../src/voucher_exchange';
import '../src/qr_code';
import '../src/animate';
import '../src/google_auth';
import '../src/credit_card_form';
import '../src/trackings/index.ts';
import '../src/anchor';
import '../src/paymentFormValidation.js';
import '../src/Order/cancel_order_unit.ts';
import '../src/Order/voucher_list_modal.js';
import '../src/snow_item_scroll_menu.js';
import '../src/fancybox_gallery.js';

import '../src/RailsUI/slider.ts';
import '../src/RailsUI/cancel_turbolinks_scroll_position.ts';
import '../src/RailsUI/participants_count_check.ts';
import '../src/RailsUI/keyword_search.ts';
import '../src/RailsUI/sticky_position.ts';
import '../src/RailsUI/facebook_page.ts';
import '../src/RailsUI/coupon_curly.ts';
import '../src/RailsUI/delay.ts';
